import { useEffect, useState } from "react";
import CheckBox from "../../../../../Components/CheckBox/CheckBox";
import LogTypesSCP from "../../../../../Services/Data/SCP/LogTypesSCP";
import "./LogsSCP.css";
import LogSCP from "./Components/LogSCP";
import ServerRequests from "../../../../../Services/Api/ServersRequests.ts";
import { useParams } from "react-router-dom";

const LogsSCP = () => {
    const serversRequests = new ServerRequests();

    const { serverId } = useParams();

    const [, setRefresh] = useState("");
    const [selectedCheckBoxes, setSelectedCheckBoxes] = useState(LogTypesSCP.map(x => x));
    const [search, setSearch] = useState("");

    const [logs, setLogs] = useState(null);

    const ChangeSelection = (logType) => {
        let data = selectedCheckBoxes;

        let existing = data.find(x => x.name == logType.name);

        if (existing) 
            data.splice(data.indexOf(existing), 1);
        else
            data.push(logType);

        setSelectedCheckBoxes(data);

        setRefresh(new Date().toISOString());
    }

    useEffect(() => {
        Search();
    }, [serverId]);

    const Search = () => {
        const filter = {
            ServerId : serverId,
            Search: search,
            LogTypes: selectedCheckBoxes.map(x => x.id)
        };

        serversRequests.SearchServerLogs(filter, (data) => {
            setLogs(data);
        });
    }

    return (
        <div className="card panelFull flex">
            <div className="logsFilterPanel">
                <div className="h-[85%]">
                    <h3 className="text-center">Filters</h3>
                    {
                        LogTypesSCP.map(logType => 
                            <CheckBox 
                                text={logType.name} 
                                onChange={() => ChangeSelection(logType)}
                                value={selectedCheckBoxes.find(x => x.name == logType.name)}
                            />
                        )
                    }

                    <div className="flex mt-10 gap-2">
                        <button className="flex-1" onClick={() => {setSelectedCheckBoxes(LogTypesSCP)}}>Select All</button>
                        <button className="flex-1" onClick={() => {setSelectedCheckBoxes([])}}>Unselect All</button>
                    </div>
                </div>
                <div className="h-[15%]">
                    <input type="text" placeholder="Search..." className="input w-100p mt-5" value={search} onChange={(e) => setSearch(e.target.value)}/>
                    <button onClick={() => Search()} className="w-100p mt-5">Apply</button>
                    
                </div>
            </div>
            <div className="w-[75%] h-100p overflow-y-auto overflow-x-hidden">
                { logs &&
                    <>
                        { logs.map((log) =>
                            <LogSCP log={log} />
                        )}                    
                    </>
                }
                { !logs &&
                    <h2>Ładowanie danych...</h2>
                }
            </div>
        </div>
    )
}

export default LogsSCP;